module.exports = __webpack_public_path__ + "static/img/ic_two.b401576.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ic_two.png
// module id = pVF1
// module chunks = 1